import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyA6e0EhaxS8hpaUES-OkV_pT25jG6twHuM",
  authDomain: "kamal-institute.firebaseapp.com",
  projectId: "kamal-institute",
  storageBucket: "kamal-institute.firebasestorage.app",
  messagingSenderId: "751878662604",
  appId: "1:751878662604:web:7d6906410accfc8de71569",
  measurementId: "G-VZ44HXB8KZ"
};

const app = initializeApp(firebaseConfig);

// Initialize analytics only in production
if (typeof window !== 'undefined') {
  getAnalytics(app);
}

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export default app;
